const initialState = {
	blog: {},
	blogs: [],
	blogCount: 0,
	blogCurrent: 1,
	followers: [],
	followerCount: 0,
	followerCurrent: 1,
	blogPage: 'MY POSTS',
	showCreateBlogModal: false
}

const blog = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_BLOGS':
			return {
				...state,
				blogs: action.blogs,
				blogCount: action.blogCount,
				blogCurrent: action.blogCurrent
			}
		case 'GET_PHYS_FOLLOWERS':
			return {
				...state,
				followers: action.followers,
				followerCount: action.followerCount,
				followerCurrent: action.followerCurrent
			}
		case 'GET_BLOG_DETAIL':
			return {
				...state,
				blog: action.blog
			}
		case 'SET_BLOG_PAGE':
			return {
				...state,
				blogPage: action.blogPage
			}

		case 'RESET_BLOG_STATE':
			return {
				...initialState
			}
		case 'SHOW_CREATE_BLOG':
			return {
				...state,
				showCreateBlogModal: action.show
			}
		default:
			return { ...state }
	}
}

export default blog
